//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    applicationSettings_GetAll(): Promise<ApplicationSettings[]> {
        let url_ = this.baseUrl + "/api/ApplicationSettings/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApplicationSettings_GetAll(_response);
        });
    }

    protected processApplicationSettings_GetAll(response: Response): Promise<ApplicationSettings[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationSettings.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationSettings[]>(null as any);
    }

    applicationSettings_GetByKind(kind: string | null): Promise<ApplicationSettings> {
        let url_ = this.baseUrl + "/api/ApplicationSettings/Get/{kind}";
        if (kind === undefined || kind === null)
            throw new Error("The parameter 'kind' must be defined.");
        url_ = url_.replace("{kind}", encodeURIComponent("" + kind));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApplicationSettings_GetByKind(_response);
        });
    }

    protected processApplicationSettings_GetByKind(response: Response): Promise<ApplicationSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationSettings>(null as any);
    }

    applicationSettings_Upsert(settings: ApplicationSettings): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ApplicationSettings/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApplicationSettings_Upsert(_response);
        });
    }

    protected processApplicationSettings_Upsert(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    contract_CreateContract(request: PhotoRequest): Promise<PhotoRequestResponse> {
        let url_ = this.baseUrl + "/Contract/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContract_CreateContract(_response);
        });
    }

    protected processContract_CreateContract(response: Response): Promise<PhotoRequestResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhotoRequestResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PhotoRequestResponse>(null as any);
    }

    contract_GetContract(uid: string | null): Promise<PhotoContractState> {
        let url_ = this.baseUrl + "/Contract/Get/{Uid}";
        if (uid === undefined || uid === null)
            throw new Error("The parameter 'uid' must be defined.");
        url_ = url_.replace("{Uid}", encodeURIComponent("" + uid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContract_GetContract(_response);
        });
    }

    protected processContract_GetContract(response: Response): Promise<PhotoContractState> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhotoContractState.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PhotoContractState>(null as any);
    }

    contract_ValidateEmpty(uid: string | null): Promise<void> {
        let url_ = this.baseUrl + "/Contract/ValidateEmpty/{Uid}";
        if (uid === undefined || uid === null)
            throw new Error("The parameter 'uid' must be defined.");
        url_ = url_.replace("{Uid}", encodeURIComponent("" + uid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContract_ValidateEmpty(_response);
        });
    }

    protected processContract_ValidateEmpty(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    contract_RemoveContract(uid: string | null): Promise<void> {
        let url_ = this.baseUrl + "/Contract/Delete/{Uid}";
        if (uid === undefined || uid === null)
            throw new Error("The parameter 'uid' must be defined.");
        url_ = url_.replace("{Uid}", encodeURIComponent("" + uid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContract_RemoveContract(_response);
        });
    }

    protected processContract_RemoveContract(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    contract_UpdateContract(data: UserValidationResponse): Promise<ValidationResponse> {
        let url_ = this.baseUrl + "/Contract/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContract_UpdateContract(_response);
        });
    }

    protected processContract_UpdateContract(response: Response): Promise<ValidationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResponse>(null as any);
    }

    contract_GetSpPhotoUrl(browserUrl: string | null, uid: string | null): Promise<void> {
        let url_ = this.baseUrl + "/Contract/GetSpPhotoUrl/{BrowserUrl}/{uid}";
        if (browserUrl === undefined || browserUrl === null)
            throw new Error("The parameter 'browserUrl' must be defined.");
        url_ = url_.replace("{BrowserUrl}", encodeURIComponent("" + browserUrl));
        if (uid === undefined || uid === null)
            throw new Error("The parameter 'uid' must be defined.");
        url_ = url_.replace("{uid}", encodeURIComponent("" + uid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContract_GetSpPhotoUrl(_response);
        });
    }

    protected processContract_GetSpPhotoUrl(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ApplicationSettings implements IApplicationSettings {
    id?: ObjectId;
    applicationName?: string;
    kind?: string;
    instructionMessage?: string;
    permissions?: ContractPermissions[];
    allowedFileTypes?: AllowedFileType[];
    createdAt?: Date;
    updatedAt?: Date;

    constructor(data?: IApplicationSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] ? ObjectId.fromJS(_data["id"]) : <any>undefined;
            this.applicationName = _data["applicationName"];
            this.kind = _data["kind"];
            this.instructionMessage = _data["instructionMessage"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            if (Array.isArray(_data["allowedFileTypes"])) {
                this.allowedFileTypes = [] as any;
                for (let item of _data["allowedFileTypes"])
                    this.allowedFileTypes!.push(item);
            }
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicationSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["applicationName"] = this.applicationName;
        data["kind"] = this.kind;
        data["instructionMessage"] = this.instructionMessage;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        if (Array.isArray(this.allowedFileTypes)) {
            data["allowedFileTypes"] = [];
            for (let item of this.allowedFileTypes)
                data["allowedFileTypes"].push(item);
        }
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IApplicationSettings {
    id?: ObjectId;
    applicationName?: string;
    kind?: string;
    instructionMessage?: string;
    permissions?: ContractPermissions[];
    allowedFileTypes?: AllowedFileType[];
    createdAt?: Date;
    updatedAt?: Date;
}

/** Represents an ObjectId (see also BsonObjectId). */
export class ObjectId implements IObjectId {
    /** Gets the timestamp. */
    timestamp?: number;
    /** Gets the machine. */
    machine?: number;
    /** Gets the PID. */
    pid?: number;
    /** Gets the increment. */
    increment?: number;
    /** Gets the creation time (derived from the timestamp). */
    creationTime?: Date;

    constructor(data?: IObjectId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["Timestamp"];
            this.machine = _data["Machine"];
            this.pid = _data["Pid"];
            this.increment = _data["Increment"];
            this.creationTime = _data["CreationTime"] ? new Date(_data["CreationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ObjectId {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Timestamp"] = this.timestamp;
        data["Machine"] = this.machine;
        data["Pid"] = this.pid;
        data["Increment"] = this.increment;
        data["CreationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }
}

/** Represents an ObjectId (see also BsonObjectId). */
export interface IObjectId {
    /** Gets the timestamp. */
    timestamp?: number;
    /** Gets the machine. */
    machine?: number;
    /** Gets the PID. */
    pid?: number;
    /** Gets the increment. */
    increment?: number;
    /** Gets the creation time (derived from the timestamp). */
    creationTime?: Date;
}

export enum ContractPermissions {
    TakePhoto = 0,
    UploadDocument = 1,
}

export enum AllowedFileType {
    JPG = 0,
    JPEG = 1,
    PNG = 2,
    PDF = 3,
}

export class PhotoRequest implements IPhotoRequest {
    reverseAPIURL?: string | undefined;
    kind?: string | undefined;
    permissions?: ContractPermissions[] | undefined;
    allowedFileTypes?: AllowedFileType[] | undefined;
    message?: string | undefined;

    constructor(data?: IPhotoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reverseAPIURL = _data["reverseAPIURL"];
            this.kind = _data["kind"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            if (Array.isArray(_data["allowedFileTypes"])) {
                this.allowedFileTypes = [] as any;
                for (let item of _data["allowedFileTypes"])
                    this.allowedFileTypes!.push(item);
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): PhotoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PhotoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reverseAPIURL"] = this.reverseAPIURL;
        data["kind"] = this.kind;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        if (Array.isArray(this.allowedFileTypes)) {
            data["allowedFileTypes"] = [];
            for (let item of this.allowedFileTypes)
                data["allowedFileTypes"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}

export interface IPhotoRequest {
    reverseAPIURL?: string | undefined;
    kind?: string | undefined;
    permissions?: ContractPermissions[] | undefined;
    allowedFileTypes?: AllowedFileType[] | undefined;
    message?: string | undefined;
}

export class PhotoRequestResponse extends PhotoRequest implements IPhotoRequestResponse {
    contractUid?: string | undefined;

    constructor(data?: IPhotoRequestResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contractUid = _data["contractUid"];
        }
    }

    static fromJS(data: any): PhotoRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PhotoRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractUid"] = this.contractUid;
        super.toJSON(data);
        return data;
    }
}

export interface IPhotoRequestResponse extends IPhotoRequest {
    contractUid?: string | undefined;
}

export class PhotoContractState extends PhotoRequestResponse implements IPhotoContractState {
    id?: ObjectId;
    createdAt?: Date;
    updatedAt?: Date;
    userEndValidated?: boolean;
    serverEndValidated?: boolean;
    hookCallbackResponse?: string | undefined;
    b64EncodedImage?: string | undefined;
    fileType?: string | undefined;
    fileExtension?: string | undefined;
    comment?: string | undefined;

    constructor(data?: IPhotoContractState) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? ObjectId.fromJS(_data["id"]) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.userEndValidated = _data["userEndValidated"];
            this.serverEndValidated = _data["serverEndValidated"];
            this.hookCallbackResponse = _data["hookCallbackResponse"];
            this.b64EncodedImage = _data["b64EncodedImage"];
            this.fileType = _data["fileType"];
            this.fileExtension = _data["fileExtension"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): PhotoContractState {
        data = typeof data === 'object' ? data : {};
        let result = new PhotoContractState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["userEndValidated"] = this.userEndValidated;
        data["serverEndValidated"] = this.serverEndValidated;
        data["hookCallbackResponse"] = this.hookCallbackResponse;
        data["b64EncodedImage"] = this.b64EncodedImage;
        data["fileType"] = this.fileType;
        data["fileExtension"] = this.fileExtension;
        data["comment"] = this.comment;
        super.toJSON(data);
        return data;
    }
}

export interface IPhotoContractState extends IPhotoRequestResponse {
    id?: ObjectId;
    createdAt?: Date;
    updatedAt?: Date;
    userEndValidated?: boolean;
    serverEndValidated?: boolean;
    hookCallbackResponse?: string | undefined;
    b64EncodedImage?: string | undefined;
    fileType?: string | undefined;
    fileExtension?: string | undefined;
    comment?: string | undefined;
}

export class ValidationResponse implements IValidationResponse {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IValidationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ValidationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IValidationResponse {
    success?: boolean;
    message?: string | undefined;
}

export class UserValidationResponse implements IUserValidationResponse {
    idReq?: string | undefined;
    b64EncodedImage?: string | undefined;
    comment?: string | undefined;

    constructor(data?: IUserValidationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idReq = _data["idReq"];
            this.b64EncodedImage = _data["b64EncodedImage"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): UserValidationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserValidationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idReq"] = this.idReq;
        data["b64EncodedImage"] = this.b64EncodedImage;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IUserValidationResponse {
    idReq?: string | undefined;
    b64EncodedImage?: string | undefined;
    comment?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}